// Toggle Admire with type selection
export const toggleAdmire = async (apiCall, targetProfileId, admireType) => {
  try {
    const response = await apiCall(`/api/admire/${targetProfileId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ admireType }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      success: true,
      data: data.data,
      message: data.message,
    };
  } catch (error) {
    throw error;
  }
};

// Remove admire
export const removeAdmire = async (apiCall, targetProfileId) => {
  try {
    const response = await apiCall(`/api/admire/${targetProfileId}`, {
      method: 'DELETE',
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      success: true,
      data: data.data,
      message: data.message,
    };
  } catch (error) {
    throw error;
  }
};

// Get Admirers
export const getAdmirers = async (apiCall, profileId, limit = 30, cursor = null) => {
  try {
    const params = new URLSearchParams({ limit: limit.toString() });
    if (cursor) params.append('cursor', cursor);

    const response = await apiCall(`/api/admire/admirers/${profileId}?${params.toString()}`, {
      method: 'GET',
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      success: true,
      admirers: data.data.admirers,
      nextCursor: data.data.nextCursor,
      hasMore: data.data.hasMore,
    };
  } catch (error) {
    throw error;
  }
};